
    const beautify = require('beautify');
    import Utils from '../components/common/utils/utils';
    import { Component, defineComponent, PropType, ref } from 'vue';
    import { default as UICopyToClipboard } from './UICopyToClipboard.vue';

    export default defineComponent({
        name: "UIExampleContainer",
        components: {
            UICopyToClipboard
        },
        props: {
            componentId: { type: String, required: true },
            name: { type: String, required: true },
            vueComponent: { type: Object as PropType<Component>, required: true },
            vueCode: { type: String, required: false },
            singleViewRouteName: { type: String, required: false },
        },
        setup(props, _context) {

            let tabs = [];
            tabs.push({ name: 'Preview', value: 'preview' });
            tabs.push({ name: 'HTML', value: 'html' });

            if (!!props.vueCode) {
                tabs.push({ name: 'Vue', value: 'vue' });
            }


            let screenSizes = [
                { name: '640px', value: '640px' },
                { name: '768px', value: '768px' },
                { name: '1024px', value: '1024px' },
                { name: '1280px', value: '1280px' }
            ];


            return {
                tabs,
                screenSizes,
                currentTab: ref('preview'),
                currentScreenSize: ref('1280px'),
                htmlCode: ref('')
            };

        },
        mounted() {
            let previewElemRef = this.$refs['previewContainer'] as Element;
            let previewNode = previewElemRef.firstChild?.cloneNode(true) as Element;

            if (!!previewNode) {
                previewNode = Utils.RemoveAttributesRecursive(previewNode, (attr) => attr.nodeName.startsWith('data-v'));   //Remove Vue.js data attributes
                this.htmlCode = beautify(previewNode.innerHTML, { format: 'html' });
            }
        },
        methods: {
            handleTabSelected(value: string) {
                this.currentTab = value;
            },
            handleScreenSizeSelected(value: string) {
                this.currentScreenSize = value;
            },
            getStandaloneComponentUrl(componentId: string) {
                var route = this.$router.resolve({ name: this.singleViewRouteName, params: { component: componentId } });
                return route.href;
            }
        }
    });
